import React from "react";
import classNames from "classnames";

import { isString } from "../../util/is.js";
import "./styles.styl";

export default function InputRadio(props) {
  const {
    className,
    label,
    name,
    value,
    options = [],
    onChange,
    horizontal,
    ...rest
  } = props;

  const controlled = !!onChange;

  const checkedProp = controlled ? "checked" : "defaultChecked";
  const normalizedOptions = normalizeOptions(options);

  return (
    <div
      className={classNames(
        "input-radio",
        { "is-horizontal": horizontal },
        className,
      )}
      {...rest}
    >
      {label && <label className="input-radio__label">{label}</label>}
      <div className="input-radio__options">
        {normalizedOptions.map((option, i) => {
          const active = option.value === value;
          const id = (name || "") + option.value;

          return (
            <div key={option.value} className="input-radio__option">
              <input
                id={id}
                className="input-radio__option__input"
                name={name}
                onChange={onChange}
                type="radio"
                value={option.value}
                {...{ [checkedProp]: active }}
              />
              <div className="input-radio__option__radio" />
              <label htmlFor={id} className="input-radio__option__text">
                {option.text}
              </label>
            </div>
          );
        })}
      </div>
    </div>
  );
}

function normalizeOptions(options) {
  return options.map((o) => (!isString(o) ? o : { value: o, text: o }));
}
